export const formatCostoMensual = (
  costo: number | null | undefined,
  moneda: string | null | undefined,
): string => {
  if (costo == null || Number.isNaN(costo)) return 'Sin costo definido';
  const code = (moneda ?? 'ARS').toUpperCase();
  try {
    return `${new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: code === 'USD' ? 'USD' : 'ARS',
      maximumFractionDigits: 2,
    }).format(costo)} / mes`;
  } catch {
    return `${code} ${costo.toFixed(2)} / mes`;
  }
};
